import { Component, OnDestroy, } from '@angular/core';
import { Destroyable$, SystemGuid, TimeFrameTypeDto } from 'webcommon/shared';
import moment from 'moment';
import { ApTimeFrameSelectorModalService } from 'webcommon/core-ui';
import { ColumnExtTimeframeDto} from './ColumnExtTimeframeDto';
import { ApColumnBase } from '../public-api';
import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'ap-column-ext-timeframe',
  templateUrl: './ap-column-ext-timeframe.component.html',
  styleUrls: ['./ap-column-ext-timeframe.component.less'],
})

export class ApColumnExtTimeFrameComponent extends ApColumnBase<ColumnExtTimeframeDto>  implements OnDestroy, Destroyable$ {
  readonly onDestroy$: Subject<void> = new Subject<void>();

  timeframe: TimeFrameTypeDto = new TimeFrameTypeDto();
  loading = true;
  formatTimeFrame = '';

  constructor(
    private systemGuid: SystemGuid,
    private apTimeFrameSelectorModalService: ApTimeFrameSelectorModalService,
  ) {
    super();
    this.loading = true;
  }

  takeUntilDestroy<T>() {
    return (source: Observable<T>): Observable<T> => {
      return source.pipe(
        takeUntil(this.onDestroy$),
      );
    };
  }

  ngOnDestroy(): void {
    this.onDestroy$.next();
    this.onDestroy$.complete();
  }

  load(): void {
    this.timeframe = this.columnInfoDto.GetExtTimeFrameCallback
      ? this.columnInfoDto.GetExtTimeFrameCallback(this.dataItem)
      : new TimeFrameTypeDto();
    this.formatTimeFrame = this.processTimeFrameDisplayText(this.timeframe);
    this.loading = false;
  }

  setSelected() {
    const el = document.getElementById(this.Id + '-Selected');
    if (el) {
      el.classList.add('pd-selected');
    }
  }

  clickName() {
    this.setSelected();
  }

  clickIcon() {
    this.setSelected();
    if (!this.dataItem.IsDelete && !this.columnInfoDto.IsReadOnly) {
       this.openTimeFrameModel();
    }
  }

  processTimeFrameDisplayText(timeframe: TimeFrameTypeDto) {
    let displayText = '';
    if (timeframe && timeframe.Id) {
      if (timeframe.Id === this.systemGuid.TimeFrame_Calendar) {
        const formattedDate = moment(timeframe.Date).format('L');
        displayText = formattedDate;
      } else if (timeframe.Id === this.systemGuid.TimeFrame_FreeText || timeframe.Id === this.systemGuid.TimeFrame_Default) {
        displayText = timeframe.Value;
      } else if (timeframe.Date) {
        const formattedDate = moment(timeframe.Date).format('L');

        if (formattedDate === timeframe.Answer) {
          displayText = formattedDate;
        } else {
          displayText = `${timeframe.Answer} (${formattedDate})`;
        }
      } else {
          if (timeframe.Id === this.systemGuid.TimeFrame_Clear) {
          displayText = '';
          } else {
            switch (timeframe.Id) {
              case this.systemGuid.TimeFrame_Teenage:
                displayText = 'Teenage';
                break;
              case this.systemGuid.TimeFrame_Birth:
                displayText = 'Birth';
                break;
              case this.systemGuid.TimeFrame_Childhood:
                displayText = 'Childhood';
                break;
              default:
                displayText = '';
            }
          }
      }
    }
    return displayText;
  }

  openTimeFrameModel() {
    const bUsePatient = true;
    const altDate = null;

    let timeframeId;
    let timeframeValue;
    const timeframe = this.timeframe;
    if (timeframe && timeframe.Id !== this.systemGuid.GuidEmpty) {
      timeframeId = timeframe.Id;
      timeframeValue = timeframe.Value;
    } else {
      timeframeId = null;
      timeframeValue = null;
    }

    this.apTimeFrameSelectorModalService.openModal(this.columnInfoDto.PatientId, this.columnInfoDto.VisitId, this.baseId,
                                                    timeframeId, timeframeValue, bUsePatient, altDate, this.columnInfoDto.timeFrameDtos)
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((result) => {
        this.onTimeframeChange(result);
      }, () => {
        //
      });
  }

  onTimeframeChange(timeFrame: TimeFrameTypeDto) {
    const result = {dataItem:this.dataItem, timeFrame};
    this.columnInfoDto.Change(result);
  }

}
